import {request, serviceUrl} from "@/utils/request";

//获取设备分类统计
export function getClassifiedDeviceCategory(spaceId, tagId,deviceName) {
    return request({
        params: {
            spaceId,
            tagId,
          deviceName
        },
        url: serviceUrl.deviceService + '/device/category/classified'
    })
}

//获取设备类型列表
export function getDeviceCategoryList() {
    return request({
        url: serviceUrl.deviceService + '/device/category/list'
    })
}

//获取没有配置告警的设备类型id
export function getCategoryIdList() {
    return request({
        url: serviceUrl.deviceService + '/device/category/getCategoryIdList'
    })
}

// 获取设备类型详情
export function getDeviceCategoryDetailList(data) {

    return request({
        method: 'POST',
        data: data,
        url: serviceUrl.deviceService + '/device/info/getDeviceDetailByDeviceType'
    })
}

// 过滤获取设备类型详情
/*
@param {Array} typeList 设备类型列表
@param {Array} modelList 设备型号列表
*/

export function getDeviceCategoryDetailListFilter(data) {
    return request({
        method: 'POST',
        data: data,
        url: serviceUrl.deviceService + '/device/info/getDeviceDetailByDeviceTypeAndDeviceModelName'
    })
}